var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 15,
    height: 15,
    transform: "translate(1266 99)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_37",
    "data-name": "Mask Group 37",
    transform: "translate(-1266 -99)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter",
    transform: "translate(1263.5 96.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M11.25,17.5H8.75A1.25,1.25,0,0,1,7.5,16.25V11.506L2.869,6.875A1.25,1.25,0,0,1,2.5,5.994V3.75A1.25,1.25,0,0,1,3.75,2.5h12.5A1.25,1.25,0,0,1,17.5,3.75V5.994a1.25,1.25,0,0,1-.369.881L12.5,11.506V16.25A1.25,1.25,0,0,1,11.25,17.5ZM3.75,3.75V5.994l5,5V16.25h2.5V10.994l5-5V3.75Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.19aaca9b7d68de0495847406bd141bed.svg";
export { ForwardRef as ReactComponent };